import { Card, Form, Select, Input, Upload, Button, message, Space } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { addSoftwareUpdateAPI } from '@/apis/softwareUpdate';
import { uploadFileAPI } from '@/apis/file';

const { Option } = Select;

const SoftwareUpdateUpload = () => {
  const [form] = Form.useForm();
  const [uploading, setUploading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);

  const customUpload = async ({ file, onSuccess, onError }) => {
    const formData = new FormData();
    formData.append('file', file);
    try {
      setUploading(true);
      const res = await uploadFileAPI(formData);
      if(res.code===0 && res.data){
        // 期望返回 fileUrl 或 fileId -> 这里假设后端 data.fileUrl
        const url = res.data.fileUrl || res.data.url || res.data;
        setFileUrl(url);
        message.success('文件上传成功');
        onSuccess(res, file);
      } else {
        message.error(res.msg || '上传失败');
        onError(new Error(res.msg || '上传失败'));
      }
    } catch (e){
      console.error(e);
      message.error('上传出错');
      onError(e);
    } finally { setUploading(false); }
  };

  const onFinish = async (values)=>{
    if(!fileUrl){ message.error('请先上传安装包'); return; }
    const { appSource, version, canUse } = values;
    try {
      setSubmitting(true);
      await addSoftwareUpdateAPI({ appSource, version, downloadUrl: fileUrl, canUse: canUse?1:0 });
      message.success('创建成功');
      form.resetFields();
      setFileUrl(null);
    } catch(e){
      console.error(e);
      message.error('创建失败');
    } finally { setSubmitting(false); }
  };

  return (
    <Card title="上传新版本软件">
      <Form form={form} labelCol={{ span:6 }} wrapperCol={{ span:14 }} onFinish={onFinish}>
        <Form.Item name="appSource" label="应用" rules={[{ required:true, message:'请选择应用'}]}>
          <Select placeholder="请选择应用">
            <Option value="design">design</Option>
            <Option value="execute">execute</Option>
            <Option value="point">point</Option>
          </Select>
        </Form.Item>
        <Form.Item name="version" label="版本号" rules={[{ required:true, message:'请输入版本号'}]}>
          <Input placeholder="例如 1.0.0" />
        </Form.Item>
        <Form.Item label="安装包" required>
          <Upload customRequest={customUpload} maxCount={1} accept=".exe,.zip,.msi,.pkg,.dmg,.tar,.gz">
            <Button icon={<UploadOutlined />} loading={uploading}>选择文件</Button>
          </Upload>
          {fileUrl && <div style={{color:'#52c41a',marginTop:8}}>已上传: {fileUrl}</div>}
        </Form.Item>
        <Form.Item name="canUse" label="可用" valuePropName="checked" initialValue={true}>
          <Input type="checkbox" />
        </Form.Item>
        <Form.Item wrapperCol={{ span:14, offset:6 }}>
          <Space>
            <Button type="primary" htmlType="submit" loading={submitting}>提交</Button>
            <Button onClick={()=>{form.resetFields(); setFileUrl(null);}} disabled={submitting}>重置</Button>
          </Space>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default SoftwareUpdateUpload;
